import produce from "immer"
import { COLOR_PICKER_CHANGE_COLOR } from "./color-picker.actions"
import type { ColorPickerAction, IColorPickerState } from "./color-picker.types"

export const colorPickerInitialState: IColorPickerState = {
  color: "#000000"
}

export function colorPickerReducer(
  currentState: IColorPickerState | undefined,
  action: ColorPickerAction
): IColorPickerState {
  const state = currentState ?? colorPickerInitialState
  switch (action.type) {
    case COLOR_PICKER_CHANGE_COLOR: {
      return changeColor(state, action.payload as string)
    }
    default: {
      return state
    }
  }
}

function changeColor(currentState: IColorPickerState, color: string): IColorPickerState {
  return produce(currentState, (draftState: IColorPickerState) => {
    draftState.color = color
  })
}
